/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetTrackingModel {
    getFixupPrototypeFunction() { return BudgetTrackingModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetTrackingModel>): BudgetTrackingModel {
        let obj = Object.assign(new BudgetTrackingModel(), model);
        BudgetTrackingModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetTrackingModel>): BudgetTrackingModel {
        if (!model) return null;
        return BudgetTrackingModel.newInstance(<BudgetTrackingModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetTrackingModel) {
        if (!obj) return;

        models.BudgetTrackingModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetTrackingModel): boolean {
        Object.setPrototypeOf(obj, BudgetTrackingModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_step === undefined) {
            this.next_step = 0;
        }
    }

    /**
     * next step no
     */
    next_step: number;

}
